const PlusSign = () => {
    return (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 14.8861V8.75579H0V6.71235H6V0.582031H8V6.71235H14V8.75579H8V14.8861H6Z" fill="currentColor" />
        </svg>
    )
}

export default PlusSign;